/**
 * Section: Deal Locator
 * ------------------------------------------------------------------------------
 * Contains highly coupled scripts to control deal locator.
 *
 * @namespace dealerLocator
 */
import log from 'salvo-lite/log'

import {register} from '@shopify/theme-sections'

import cssClasses from '../helpers/cssClasses'

class DealerLocator {
    constructor () {
        this._selectors = {
            container: '[js-dealer="container"]',
            title: '[js-dealer="title"]'
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit (theme, section) {
        register('dealer-locator', {

            /**
             * Component selectors.
             */
            nodeSelectors () {
                this.container = document.querySelector(this.section._selectors.container)
                this.title = document.querySelector(this.section._selectors.title)
            },

            /**
             * Test to see if app has loaded.
             */
            checkLoadStatus () {
                window.dealerInterval = window.setInterval(() => {
                    const sidePanel = document.querySelector('.stockist-side-panel')

                    if (sidePanel === null) {
                        return
                    }

                    this.repositionHeader(sidePanel)
                    window.clearInterval(window.dealerInterval)
                }, 500)
            },

            /**
             * Reposition the header to be in the sidebar.
             * @param {Object} sidePanel the sidebar object.
             */
            repositionHeader (sidePanel) {
                sidePanel.insertBefore(this.title, sidePanel.firstChild)
                this.title.classList.add(cssClasses.active)
            },

            /**
             * Initialise component.
             */
            init () {
                this.section = theme.getSectionsByType('dealer-locator')
                this.nodeSelectors()
                this.checkLoadStatus()
            },

            onLoad () {
                this.init()
            }
        })
    }
}

export default DealerLocator



// WEBPACK FOOTER //
// ./src/resources/scripts/sections/DealerLocator.js